import * as constants from './config/constants.js';
import RequestHandler from './utils/request-handler.js';
import LoadingOverlay from './loading-overlay.js';

export default class BillCapping {
    constructor() {
        this.decisionElements = document.querySelectorAll('[data-bill-capping-decision] input[type="radio"]');
        this.amountElements = document.querySelectorAll('[data-bill-capping-amount]');
        this.requestHandler = new RequestHandler;
        this.responseMessage = document.querySelector('[data-bill-capping-response-message]');
        this.loadingOverlay = new LoadingOverlay;
    }

    setup() {
        this.setupDecisionSelectionListener();
        this.setupAmountSelectionListener();
    }

    setupDecisionSelectionListener() {
        this.decisionElements.forEach((el) => {
            this.billCappingAjaxCall(el, 'billCappingDecision');
        });
    }

    setupAmountSelectionListener() {
        this.amountElements.forEach((el) => {
            this.billCappingAjaxCall(el, 'billCappingAmount');
        });
    }

    billCappingCallBack(response) {
        if (response.message) {
            this.responseMessage.innerText = response.message;
        } else {
            this.responseMessage.innerText = 'An unexpected error occurred. Please try again;';
        }
        this.responseMessage.classList.remove(constants.ALERT_ERROR_CLASS, constants.ALERT_SUCCESS_CLASS);
        this.responseMessage.classList.add(constants.ALERT_CLASS);

        if (response.result == 'success') {
            this.responseMessage.classList.add(constants.ALERT_SUCCESS_CLASS);
        } else {
            this.responseMessage.classList.add(constants.ALERT_ERROR_CLASS);
        }
        this.loadingOverlay.taskFinished();
    }

    billCappingAjaxCall(el, name) {
        el.addEventListener('change', (e) => {
            const publicId = e.target.closest('[data-bill-capping-basket-section]').dataset.dealLinePublicId;

            let data = `publicId=${publicId}&${name}=${e.target.value}`;
            let amountElementId = `#form_${publicId}_billCappingAmount`;
            let amountElement = document.querySelector(amountElementId);

            if (name == 'billCappingDecision') {
                if (e.target.value == 1 && (amountElement.value == '')) {
                    return;
                }
            }

            if (name == 'billCappingAmount') {
                if (e.target.value == '') {
                    return;
                }
                if (data.includes('billCappingDecision') == 0) {
                    const additionalParam = '&billCappingDecision=1';
                    data = data.concat(additionalParam);
                }
            }
            this.loadingOverlay.taskStarted();
            this.requestHandler.post('/basket/bill-capping',
                data,
                this.billCappingCallBack.bind(this)
            );
        });
    }
}
